import React, { useEffect, useState } from "react";

const JobApply = ({ jobId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [job, setJob] = useState(null);
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
  useEffect(() => {
    const fetchJobDetail = async () => {
      try {
        const response = await fetch(api_endpoint + `/api/jobs/${jobId}`);
        const data = await response.json();

        setJob(data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    if (jobId) {
      fetchJobDetail();
    }
  }, [jobId]);



  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="job-apply-container">
      <h3>Jelentkezés az állásra.</h3>
      <div>
          <img
            src={job.logo}
            alt={`${job.company} logo`}
            width='30'
            height='30'
            style={{ marginRight: '10px' }}
          />
            <h3 className="skill-group-h3">{job.name}</h3>
        <div className="job-description">
          <p>{job.description || "No description provided."}</p>
        </div>



      </div>
    </div>
  );
};

export default JobApply;
